import { render, staticRenderFns } from "./links.vue?vue&type=template&id=1607e651&scoped=true&"
var script = {}
import style0 from "./links.vue?vue&type=style&index=0&id=1607e651&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1607e651",
  null
  
)

export default component.exports